import { Button, UIHeading1, UIText1 } from '@cian/ui-kit';
import * as React from 'react';
import { NBSP } from 'shared/constants/symbols';

import * as styles from './styles.css';

export interface INewbuildingPrizeBannerProps {
  onClick: () => void;
  url: string;
}

export const NewbuildingPrizeBanner: React.FC<INewbuildingPrizeBannerProps> = ({ onClick, url }) => {
  return (
    <a
      className={styles['container']}
      data-testid="NewbuildingPrizeBanner"
      href={url}
      rel="noopener noreferrer"
      target="_blank"
      onClick={onClick}
    >
      <div className={styles['content']}>
        <div className={styles['text-group']}>
          <UIHeading1 color="text-inverted-default">
            350{NBSP}000{NBSP}₽ за{NBSP}покупку новостройки
          </UIHeading1>
          <UIText1 color="text-inverted-default">Разыграем приятный бонус на{NBSP}новоселье</UIText1>
        </div>

        <Button size="M" theme="fill_white_primary" type="button">
          Как получить приз
        </Button>
      </div>

      <div aria-hidden={true} className={styles['image-slot']} />
    </a>
  );
};
